// pages/Dashboard.jsx
import DashboardLayout from "../../components/dashboard/DashboardLayout";
import AdminCityDashboard from "../../components/dashboard/AdminCityDashboard";

export default function Dashboard() {
  return (
    <DashboardLayout>
      <AdminCityDashboard />
    </DashboardLayout>
  );
}
